








import Vue from 'vue';
import CommonLayout from '@/components/common/common-layout.component.vue';

export default Vue.extend({
  name: 'App',
  components: {
    'common-layout': CommonLayout
  },
  setup() {
    //
  }
});
